<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="filter1"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="filter1"></ng-container>
        <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="filter1"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <div class="headercc1">
        @if(israiltravel) {
        <div [class.headercc2]="type === 'railtravel'" [class.headercc4]="type !== 'railtravel'" (click)="setBahn()">
            <div multilang>{{'Bahnreisen'}}</div>
        </div>
        } @else {
        <div [class.headercc2]="type === 'pauschal'" [class.headercc4]="type !== 'pauschal'" (click)="setPauschal()">
            <div multilang>{{'Pauschalreisen'}}</div>
        </div>
        }
        <div [class.headercc3]="type !== 'hotelonly'" [class.headercc2]="type === 'hotelonly'" (click)="setHotelonly()">
            <div multilang>{{'Hotels'}}</div>
        </div>
    </div>
    <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <clever-reiseziel [mode]="'home'" [type]="type" style="width:320px"
                [completion]="completion"></clever-reiseziel>
            @if(type === 'pauschal') {
            <clever-airport [mode]="'home'"></clever-airport>
            }
            @if(type === 'railtravel') {
            <clever-reil [mode]="'home'"></clever-reil>
            }
            @if(type === 'hotelonly') {
            <clever-roomtype [mode]="'home'"></clever-roomtype>
            }
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-dauer style="width: 130px;" [mode]="'home'"></clever-dauer>
            <clever-traveller style="width: 130px;" [mode]="'home'" (sendRes)=" resTraveler($event)"
                [reisende]="filter?.reisendeResult"></clever-traveller>
            <button class="morefilter" matTooltip="Mehr Filter" aria-label="Mehr Filter" (click)="openclosemore()"
                matRipple>
                <span multilang>Mehr Filter</span>
                @if(showMore){
                <mat-icon>keyboard_arrow_up</mat-icon>
                }@else{
                <mat-icon>keyboard_arrow_down</mat-icon>
                }
            </button>
            <button class="tmpsearch tmpbtn tmp-right" (click)="gotoZiel(true)" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext}}</span>
            </button>

        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="smallVersion"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="smallVersion"></ng-container>
        <ng-container *ngSwitchCase="'md'" [ngTemplateOutlet]="smallVersion"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="filter2"></ng-container>
    </ng-container>

</ng-template>

<ng-template #smallVersion>
    <div class="filter-container">
        @if(showSmallFilter && this.media !== "xl"){
        <button id="smallFilter" class="small-filter" (click)="openLargeFilter()">
            <div class="search">
                <mat-icon class="search-icon" fontIcon="search"></mat-icon>
            </div>
            <div class="information">
                <div class="destination">
                    <clever-reiseziel [mode]="'nohomesmall'" [type]="type" [completion]="completion"></clever-reiseziel>
                </div>
                <div class="additional">
                    <div class="date">
                        <span>{{start | date:'dd.MM.yy'}} - {{end |
                            date:'dd.MM.yy'}}</span> -
                    </div>
                    <div class="duration">
                        <clever-dauer-small></clever-dauer-small>,
                    </div>
                    <div class="traveller">
                        <span multilang>{{filter?.reisendeResult?.adults}} Erwachsene</span>
                        @if(filter?.reisendeResult?.children?.length){
                        <span multilang>+{{filter?.reisendeResult?.children.length}} Kind</span>
                        }
                    </div>
                </div>
            </div>
        </button>
        }@else{
        <div id="largeFilter">
            <ng-container *ngTemplateOutlet="filter2"></ng-container>
            <div class="close-btn">
                <button id="closeButton" (click)="closeLargeFilter()" matRipple><mat-icon
                        class="close-icon ">close</mat-icon></button>
            </div>
        </div>
        }
    </div>
</ng-template>

<ng-template #filter1>
    <div style="width:100%;display:flex;flex-direction: column;align-items: center;">
        <div
            style="width:320px;display:flex;flex-direction: column;align-items: center;background-color: #fff;border-radius:1rem;">

            <ng-container *ngTemplateOutlet="filterTab1"></ng-container>
            <ng-container *ngTemplateOutlet="filterFields"></ng-container>
        </div>

    </div>
</ng-template>

<ng-template #filter2>
    <ng-container *ngTemplateOutlet="filterTab2"></ng-container>
    <ng-container *ngTemplateOutlet="filterFields"></ng-container>
</ng-template>

<ng-template #filterTab1>
    <div class="tabs disco dancer">
        @if(israiltravel) {
        <button class="tab tab-l" [class.activeType]="type == 'railtravel'" (click)="setBahn()">
            <span multilang>
                {{'Bahnreisen'}}
            </span>
        </button>
        } @else {
        <button class="tab tab-l" [class.activeType]="type == 'pauschal'" (click)="setPauschal()">
            <span multilang>{{'Pauschalreisen'}}</span>
        </button>
        }
        <button class="tab tab-r" [class.activeType]="type === 'hotelonly'" (click)="setHotelonly()">
            <span multilang>{{'Nur Hotel'}}</span>
        </button>
    </div>
</ng-template>

<ng-template #filterTab2>
    <div class="tabs">
        @if(israiltravel) {
        <button class="tab tab-l" [class.activeType]="type === 'railtravel'" (click)="switchTo('railtravel')">
            <span multilang>
                {{'Bahnreisen'}}
            </span>
        </button>
        } @else {
        <button class="tab tab-l" [class.activeType]="type === 'pauschal'" (click)="switchTo('pauschal')">
            <span multilang>{{'Pauschalreisen'}}</span>
        </button>
        }
        <button class="tab tab-r" [class.activeType]="type === 'hotelonly'" (click)="switchTo('hotelonly')">
            <span multilang>{{'Nur Hotel'}}</span>
        </button>
    </div>
</ng-template>

<ng-template #filterFields>
    <clever-reiseziel [mode]="'nohome'" [type]="type" class="full-length" [completion]="completion"></clever-reiseziel>
    <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'nohome'"
        class="full-length"></clever-date>
    @if(type == 'pauschal'){
    <clever-airport [mode]="'nohome'" [norightborder]="false" [bottomleftradius]="false"
        class="full-length"></clever-airport>
    }
    @if(type == 'railtravel'){
    <clever-reil [mode]="'nohome'" class="full-length"></clever-reil>
    }
    <div class="custsection">
        <clever-dauer [mode]="'nohome'" class="half-length"></clever-dauer>
        <clever-traveller [mode]="'nohome'" class="half-length" (sendRes)="resTraveler($event)"
            [reisende]="filter?.reisendeResult"></clever-traveller>
    </div>
    @if(mode=="home"){
    <button style="margin-top:0.5rem;" matTooltip="Mehr Filter" aria-label="Mehr Filter" (click)="openclosemore()"
        matRipple>
        <span multilang>Mehr Filter</span>
        @if(showMore){
        <mat-icon>keyboard_arrow_up</mat-icon>
        }@else{
        <mat-icon>keyboard_arrow_down</mat-icon>
        }
    </button>
    }
    <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    <button class="search-btn" (click)="gotoZiel(false)" matRipple>
        <mat-icon class="search-icon-white" fontIcon="search"></mat-icon>
        <span multilang>{{btntext}}</span>
    </button>
</ng-template>

<ng-template #moreFilter>
    <clever-hotelextrafilter [mode]="'home'" [type]="type" class="w100" (closeModal)="openclosemore()">
    </clever-hotelextrafilter>
</ng-template>